import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import {communicator} from "@/util/communicator";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

export default new Vuex.Store({
    state: {
        auth: "",
        accountInfos: {},
        organisations: [],
        locations: [],
        communities: [],
    },
    mutations: {
        SET_AUTH(state, auth) {
            state.auth = auth;
        },
        SET_ACCOUNTINFOS(state, accountInfos) {
            state.accountInfos = accountInfos;
        },
        SET_ORGANISATIONS(state, organisations) {
            state.organisations = organisations;
        },
        SET_LOCATIONS(state, locations) {
            state.locations = locations;
        },
        SET_COMMUNITIES(state, communities) {
            state.communities = communities;
        },
    },
    actions: {
        async FETCH_ACCOUNTINFOS({commit}) {
            const response = await communicator.get("/account");
            console.log("[store] Got account: ", response);
            commit("SET_ACCOUNTINFOS", response.data);
        },
        async FETCH_ORGANISATIONS({commit}) {
            const response = await communicator.get("/organisations");
            console.log("[store] Got organisations: ", response);
            commit("SET_ORGANISATIONS", response.data.items);
        },
        async FETCH_ORGANISATION({commit}, id) {
            const response = await communicator.get("/organisations/" + id);
            console.log("[store] Got organisation: ", response);
            commit("SET_ORGANISATIONS", [response.data]);
        },
        async FETCH_LOCATIONS({commit}) {
            const response = await communicator.get("/locations");
            console.log("[store] Got locations: ", response);
            commit("SET_LOCATIONS", response.data.items);
        },
        async FETCH_LOCATION({commit}, id) {
            const response = await communicator.get("/locations/" + id);
            console.log("[store] Got location: ", response);
            commit("SET_LOCATIONS", [response.data]);
        },
        async FETCH_COMMUNITIES({commit}) {
            const response = await communicator.get("/communities/backoffice");
            console.log("[store] Got communities: ", response);
            commit("SET_COMMUNITIES", response.data.items);
        },
        async FETCH_COMMUNITY({commit}, id) {
            const response = await communicator.get("/communities" + id);
            console.log("[store] Got community: ", response);
            commit("SET_COMMUNITIES", [response.data]);
        },
    },
    plugins: [vuexLocal.plugin]
});
